import type {
  EventHandlerCb,
  ExtendedConstraints,
  CapabilityConfig,
} from '../../types';
import { hasOnlyKeysFromSet } from '../../utils';

export const id = 'ping-pong';

export enum Events {
  Ping = 'ping-pong:ping-runtime',
  Song = 'ping-pong:song-runtime',
}
export enum Actions {
  Sing = 'ping-pong:sing-host',
  Pong = 'ping-pong:pong-host',
}

export type PingPayload = {
  pingTime: string;
  pongTime?: string;
};

const VALID_CONFIG_KEYS = ['type'] as const;
export type Config = CapabilityConfig & {
  type: typeof id;
};

export type Constraints = ExtendedConstraints<{
  events: Events;
  actions: Actions;
  config: Config;

  eventPayloadTuple: [Events.Ping, PingPayload] | [Events.Song, PingPayload];
  eventHandlerTuple:
    | [Events.Ping, EventHandlerCb<PingPayload>]
    | [Events.Song, EventHandlerCb<PingPayload>];
  actionPayloadTuple: [Actions.Sing, PingPayload] | [Actions.Pong, PingPayload];
}>;

export function isValidConfig(config: CapabilityConfig): boolean {
  return hasOnlyKeysFromSet(config, VALID_CONFIG_KEYS);
}
